module.exports = {
	"data": [
		{
			"id": 0,
			"follower": 16125,
			"name": "王凱文",
			"title": "MDA 代表選手",
			"media": "news",
			"label": "媒體報導",
			"photo": "/images/user-avatar-1.png"
		},
		{
			"id": 1,
			"follower": 62221,
			"name": "廖德合",
			"title": "梅信酒店 國宴主廚",
			"media": "twitter",
			"label": "跟隨者",
			"photo": "/images/user-avatar-2.png"
		},
		{
			"id": 2,
			"follower": 23393,
			"name": "梅芳藍",
			"title": "四度美學 美術總監",
			"media": "facebook",
			"label": "追蹤者",
			"photo": "/images/user-avatar-3.png"
		},
		{
			"id": 3,
			"follower": 99017,
			"name": "楊信",
			"title": "洪頁食品 執行長",
			"media": "facebook",
			"label": "追蹤者",
			"photo": "/images/user-avatar-4.png"
		},
		{
			"id": 4,
			"follower": 156729,
			"name": "蕭示遠",
			"title": "偉奕科技 技術總監",
			"media": "twitter",
			"label": "跟隨者",
			"photo": "/images/user-avatar-5.png"
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/javascripts/introduction/slider_data.json
 ** module id = 190
 ** module chunks = 1
 **/